import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Button } from '@lacedltd/laced-components'

export const PauseFormWrap = styled.div({
  form: {
    margin: 0,

    div: {
      marginBottom: tokens.spacing[3]
    },

    button: {
      marginTop: tokens.spacing[5],
      width: '100%'
    }
  }
})

export const PauseListingButton = styled.button({
  appearance: 'none',
  cursor: 'pointer',
  background: 'transparent',
  border: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[200]}`,
  borderRadius: tokens.borderRadius.s,
  color: tokens.color.airJordan[500],
  fontSize: tokens.fontSize[1],
  padding: `${tokens.spacing[1]} ${tokens.spacing[3]}`,
  lineHeight: 1.4,
  textAlign: 'center',
  whiteSpace: 'nowrap',
  transition: 'all 0.15s ease',

  '&:hover': {
    borderColor: tokens.color.airJordan[400],
    color: tokens.color.airJordan.p
  }
})

// Full-size button for use in modals
export const PauseModalButton = styled(Button)({})
